import { useEffect, useRef } from 'react';

function useDelayedFunction(onTimeout) {
  const timeoutRef = useRef(null);

  const handleMouseEnter = value => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      onTimeout(value);
    }, 300);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeoutRef.current);
  };

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return { handleMouseEnter, handleMouseLeave };
}

export default useDelayedFunction;
